import { roles } from "./roles";

export const permissionMap = roles;
